import React, { useState, useEffect, useRef } from "react";
import api from "../utils/axiosInstance";
import "bootstrap-icons/font/bootstrap-icons.css";
import InAppViewer from "./InAppViewer";

import { getApiBase } from "../utils/useApiBase";
const PHOTO_MAX_SIZE = 2 * 1024 * 1024;
const allowedPhotoTypes = new Set(["image/jpeg", "image/png"]);
const allowedPhotoExtensions = /\.(jpe?g|png)$/i;
const API_BASE = process.env.REACT_APP_API_URL || "";
const getPhotoUrl = (filename) =>
  filename ? `${API_BASE}/uploads/photos/${filename}` : "";
const handleImgError = (e) => { e.target.style.display = "none"; e.target.nextSibling && (e.target.nextSibling.style.display = "flex"); };

const Abana = ({ isUmudugudu = false }) => {
  const API_URL = isUmudugudu
    ? `${getApiBase()}/umudugudu/module-data/abana`
    : `${getApiBase()}/abana`;
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [selectedChild, setSelectedChild] = useState(null);
  const [editId, setEditId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterGender, setFilterGender] = useState("all");
  const [filterSchool, setFilterSchool] = useState("all");
  const [filterAge, setFilterAge] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [expandedCard, setExpandedCard] = useState(null);
  const [viewerFile, setViewerFile] = useState(null);
  const perPage = 10;

  const [stats, setStats] = useState({
    total: 0, male: 0, female: 0, inSchool: 0, notInSchool: 0,
    avgAge: 0, under5: 0, age5to12: 0, age13to18: 0,
  });

  const initialForm = {
    amazina: "", imyaka: "", igitsina: "Gabo",
    umubyeyi_wa_mwana: "", aderesi: "", ariga: "Yego", ifoto: "",
    ijyipande_cy_amavuko: "",
  };

  const [form, setForm] = useState(initialForm);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedIjyipande, setSelectedIjyipande] = useState(null);
  const [formErrors, setFormErrors] = useState({});

  const calculateStats = (arr) => {
    if (!arr?.length) {
      setStats({ total: 0, male: 0, female: 0, inSchool: 0, notInSchool: 0, avgAge: 0, under5: 0, age5to12: 0, age13to18: 0 });
      return;
    }
    const totalAge = arr.reduce((s, i) => s + Number(i.imyaka || 0), 0);
    setStats({
      total: arr.length,
      male: arr.filter(i => i.igitsina === "Gabo").length,
      female: arr.filter(i => i.igitsina === "Gore").length,
      inSchool: arr.filter(i => i.ariga === "Yego").length,
      notInSchool: arr.filter(i => i.ariga === "Oya").length,
      avgAge: (totalAge / arr.length).toFixed(1),
      under5: arr.filter(i => Number(i.imyaka) < 5).length,
      age5to12: arr.filter(i => { const a = Number(i.imyaka); return a >= 5 && a <= 12; }).length,
      age13to18: arr.filter(i => { const a = Number(i.imyaka); return a >= 13 && a <= 18; }).length,
    });
  };

  const showAlertMsg = (message, variant = "ok") => {
    setAlert({ message, variant });
    setTimeout(() => setAlert(null), 4500);
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await api.get(API_URL);
      const raw = res.data;
      const items = Array.isArray(raw) ? raw : (Array.isArray(raw?.data) ? raw.data : []);
      setData(items);
      setFilteredData(items);
      calculateStats(items);
    } catch {
      showAlertMsg("Habaye ikosa mu gusoma amakuru!", "err");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadData(); }, []);

  useEffect(() => {
    let r = [...data];
    if (searchTerm.trim()) {
      const t = searchTerm.toLowerCase();
      r = r.filter(i =>
        i.amazina?.toLowerCase().includes(t) ||
        i.umubyeyi_wa_mwana?.toLowerCase().includes(t) ||
        i.aderesi?.toLowerCase().includes(t)
      );
    }
    if (filterGender !== "all") r = r.filter(i => i.igitsina === filterGender);
    if (filterSchool !== "all") r = r.filter(i => i.ariga === filterSchool);
    if (filterAge !== "all") {
      r = r.filter(i => {
        const a = Number(i.imyaka);
        if (filterAge === "under5") return a < 5;
        if (filterAge === "5-12") return a >= 5 && a <= 12;
        if (filterAge === "13-18") return a >= 13 && a <= 18;
        return true;
      });
    }
    setFilteredData(r);
    setCurrentPage(1);
  }, [searchTerm, filterGender, filterSchool, filterAge, data]);

  const lastIdx = currentPage * perPage;
  const firstIdx = lastIdx - perPage;
  const pageItems = filteredData.slice(firstIdx, lastIdx);
  const totalPages = Math.ceil(filteredData.length / perPage);

  const validate = () => {
    const e = {};
    if (!form.amazina?.trim()) e.amazina = "Amazina ni ngombwa";
    if (!form.imyaka || form.imyaka < 0 || form.imyaka > 18) e.imyaka = "Imyaka: 0-18";
    if (!form.umubyeyi_wa_mwana?.trim()) e.umubyeyi_wa_mwana = "Umubyeyi ni ngombwa";
    setFormErrors(e);
    return !Object.keys(e).length;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(p => ({ ...p, [name]: value }));
    if (formErrors[name]) setFormErrors(p => ({ ...p, [name]: "" }));
  };

  const resetForm = () => { setForm(initialForm); setSelectedFile(null); setSelectedIjyipande(null); setFormErrors({}); setEditId(null); };

  const openDocViewer = (filename) => setViewerFile(filename);
  const closeDocViewer = () => setViewerFile(null);

  const handleSave = async () => {
    if (!validate()) return showAlertMsg("Uzuza neza amakuru!", "warn");
    try {
      const formData = new FormData();
      Object.entries(form).forEach(([key, value]) => {
        if (key !== "ifoto" && key !== "ijyipande_cy_amavuko") formData.append(key, value ?? "");
      });
      if (selectedFile) formData.append("ifoto", selectedFile);
      if (selectedIjyipande) formData.append("ijyipande_cy_amavuko", selectedIjyipande);

      if (editId) {
        await api.put(`${API_URL}/${editId}`, formData, { headers: { "Content-Type": "multipart/form-data" } });
        showAlertMsg("Amakuru yahinduwe neza!");
      } else {
        await api.post(API_URL, formData, { headers: { "Content-Type": "multipart/form-data" } });
        showAlertMsg("Umwana yashyizwemo neza!");
      }
      setShowModal(false);
      resetForm();
      loadData();
    } catch {
      showAlertMsg("Ntibikunze kubika!", "err");
    }
  };

  const handleEdit = (item) => {
    setForm({
      amazina: item.amazina || "",
      imyaka: item.imyaka || "",
      igitsina: item.igitsina || "Gabo",
      umubyeyi_wa_mwana: item.umubyeyi_wa_mwana || "",
      aderesi: item.aderesi || "",
      ariga: item.ariga || "Yego",
      ifoto: item.ifoto || "",
      ijyipande_cy_amavuko: item.ijyipande_cy_amavuko || "",
    });
    setSelectedFile(null);
    setSelectedIjyipande(null);
    setEditId(item.id);
    setFormErrors({});
    setShowModal(true);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) {
      setSelectedFile(null);
      setForm((prev) => ({ ...prev, ifoto: editId ? prev.ifoto : "" }));
      setFormErrors((prev) => {
        const next = { ...prev };
        delete next.ifoto;
        return next;
      });
      return;
    }

    if (
      ((!allowedPhotoTypes.has(file.type) && file.type) ||
        !allowedPhotoExtensions.test(file.name || ""))
    ) {
      setSelectedFile(null);
      setFormErrors((prev) => ({
        ...prev,
        ifoto: "Ifoto igomba kuba JPG, JPEG cyangwa PNG",
      }));
      e.target.value = "";
      return;
    }

    if (file.size > PHOTO_MAX_SIZE) {
      setSelectedFile(null);
      setFormErrors((prev) => ({
        ...prev,
        ifoto: "Ifoto ntigomba kurenza 2MB",
      }));
      e.target.value = "";
      return;
    }

    setSelectedFile(file);
    setForm((prev) => ({ ...prev, ifoto: file.name }));
    setFormErrors((prev) => {
      const next = { ...prev };
      delete next.ifoto;
      return next;
    });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Uremeza ko ushaka gusiba uyu mwana?")) return;
    try {
      await api.delete(`${API_URL}/${id}`);
      showAlertMsg("Yasibwe neza!");
      loadData();
    } catch {
      showAlertMsg("Ntibikunze gusiba!", "err");
    }
  };

  const exportCSV = () => {
    const h = ["Amazina", "Imyaka", "Igitsina", "Umubyeyi", "Aderesi", "Ariga"];
    const rows = filteredData.map(i => [i.amazina, i.imyaka, i.igitsina, i.umubyeyi_wa_mwana, i.aderesi || "-", i.ariga]);
    const csv = [h.join(","), ...rows.map(r => r.join(","))].join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `abana_${new Date().toISOString().split("T")[0]}.csv`;
    a.click();
    showAlertMsg("Excel yakoboye neza!");
  };

  const getAgeTagClass = (age) => {
    const a = Number(age);
    if (a < 5) return "ab-tag-cyan";
    if (a <= 12) return "ab-tag-blue";
    return "ab-tag-amber";
  };

  // Dropdown filter component
  const DropFilter = ({ icon, label, value, options, onChange }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const isActive = value !== "all";

    useEffect(() => {
      if (!open) return;
      const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
      document.addEventListener("mousedown", handler);
      document.addEventListener("touchstart", handler);
      return () => { document.removeEventListener("mousedown", handler); document.removeEventListener("touchstart", handler); };
    }, [open]);

    return (
      <div ref={ref} style={{ position: "relative" }}>
        <button className={`ab-filter-btn${isActive ? " active" : ""}`} onClick={() => setOpen(!open)}>
          <i className={`bi bi-${icon}`}></i>
          <span>{isActive ? options.find(o => o.v === value)?.l || label : label}</span>
          <i className={`bi bi-chevron-${open ? "up" : "down"}`} style={{ marginLeft: "auto", fontSize: "0.65rem", opacity: 0.5 }}></i>
        </button>
        {open && (
          <div className="ab-dropdown">
            {options.map(o => (
              <button key={o.v} className={`ab-drop-item${value === o.v ? " sel" : ""}`}
                onClick={() => { onChange(o.v); setOpen(false); }}>
                {value === o.v && <i className="bi bi-check2" style={{ color: "#0B3D91" }}></i>}
                {o.l}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  };

  const renderPagination = () => {
    if (totalPages <= 1) return null;
    const pages = [];
    const s = Math.max(1, currentPage - 2);
    const e = Math.min(totalPages, currentPage + 2);
    for (let i = s; i <= e; i++) pages.push(i);

    return (
      <div className="ab-pagination">
        <span className="ab-pg-info">
          {firstIdx + 1}–{Math.min(lastIdx, filteredData.length)} kuri {filteredData.length}
        </span>
        <div className="ab-pg-btns">
          <button className="ab-pg-btn" disabled={currentPage === 1} onClick={() => setCurrentPage(1)}>
            <i className="bi bi-chevron-double-left"></i>
          </button>
          <button className="ab-pg-btn" disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)}>
            <i className="bi bi-chevron-left"></i>
          </button>
          {pages.map(p => (
            <button key={p} className={`ab-pg-btn${p === currentPage ? " active" : ""}`} onClick={() => setCurrentPage(p)}>{p}</button>
          ))}
          <button className="ab-pg-btn" disabled={currentPage === totalPages} onClick={() => setCurrentPage(p => p + 1)}>
            <i className="bi bi-chevron-right"></i>
          </button>
          <button className="ab-pg-btn" disabled={currentPage === totalPages} onClick={() => setCurrentPage(totalPages)}>
            <i className="bi bi-chevron-double-right"></i>
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;500;600;700;800;900&display=swap');

        .ab-root *, .ab-root *::before, .ab-root *::after {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
          font-family: 'Nunito Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
          -webkit-tap-highlight-color: transparent;
        }

        .ab-root {
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        .ab-root ::-webkit-scrollbar { width: 5px; height: 5px; }
        .ab-root ::-webkit-scrollbar-track { background: transparent; }
        .ab-root ::-webkit-scrollbar-thumb { background: rgba(11,61,145,0.22); border-radius: 10px; }

        @keyframes abUp {
          from { opacity: 0; transform: translateY(22px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes abScale {
          from { opacity: 0; transform: scale(0.94); }
          to { opacity: 1; transform: scale(1); }
        }
        @keyframes abSlide {
          from { opacity: 0; transform: translateX(-14px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes abPop {
          0% { opacity: 0; transform: translateY(-12px) scale(0.94); }
          60% { transform: translateY(2px) scale(1.01); }
          100% { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes abGrad {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        @keyframes abPulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(11,61,145,0); }
          50% { box-shadow: 0 0 0 7px rgba(11,61,145,0.05); }
        }
        @keyframes abDot {
          0%, 80%, 100% { transform: scale(0); }
          40% { transform: scale(1); }
        }
        @keyframes abFloat {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-5px); }
        }
        @keyframes abCount {
          from { opacity: 0; transform: translateY(6px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes abGlow {
          0%, 100% { border-color: rgba(11,61,145,0.08); }
          50% { border-color: rgba(11,61,145,0.25); }
        }
        @keyframes abShine {
          0% { left: -100%; }
          100% { left: 200%; }
        }

        .ab-shell {
          min-height: 100vh;
          min-height: 100dvh;
          background: #ffffff;
          color: #0d1b2a;
          position: relative;
          overflow-x: hidden;
        }
        .ab-shell::before {
          content: '';
          position: fixed;
          inset: 0;
          background:
            radial-gradient(ellipse 65% 45% at 12% 8%, rgba(11,61,145,0.06) 0%, transparent 52%),
            radial-gradient(ellipse 50% 65% at 88% 88%, rgba(3,105,161,0.04) 0%, transparent 48%),
            radial-gradient(ellipse 35% 35% at 50% 50%, rgba(11,61,145,0.025) 0%, transparent 40%);
          pointer-events: none;
          z-index: 0;
        }

        .ab-layer { position: relative; z-index: 1; }
        .ab-wrap {
          max-width: 1420px;
          margin: 0 auto;
          padding: 20px 16px 44px;
        }

        /* ── HEADER ── */
        .ab-header {
          text-align: center;
          margin-bottom: 28px;
          animation: abUp 0.5s ease;
        }
        .ab-chip {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 5px 14px;
          border-radius: 10px;
          background: rgba(11,61,145,0.08);
          border: 1px solid rgba(11,61,145,0.16);
          color: #0B3D91;
          font-size: 0.66rem;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          margin-bottom: 12px;
        }
        .ab-title {
          font-size: clamp(1.5rem, 5vw, 2.6rem);
          font-weight: 900;
          line-height: 1.08;
          margin-bottom: 6px;
          background: linear-gradient(135deg, #0B3D91, #0B3D91, #0B3D91, #0B3D91);
          background-size: 300% 300%;
          animation: abGrad 7s ease infinite;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .ab-sub {
          color: #64748b;
          font-size: clamp(0.82rem, 2vw, 0.95rem);
          max-width: 440px;
          margin: 0 auto;
        }

        /* ── ACTION BAR ── */
        .ab-actions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          justify-content: center;
          margin-bottom: 24px;
          animation: abUp 0.55s ease;
        }
        .ab-btn {
          padding: 10px 20px;
          border-radius: 12px;
          font-weight: 650;
          font-size: 0.84rem;
          font-family: inherit;
          cursor: pointer;
          transition: all 0.3s ease;
          display: inline-flex;
          align-items: center;
          gap: 7px;
          border: none;
          white-space: nowrap;
          position: relative;
          overflow: hidden;
        }
        .ab-btn::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 0;
          height: 0;
          background: rgba(11,61,145,0.08);
          border-radius: 50%;
          transform: translate(-50%, -50%);
          transition: width 0.5s, height 0.5s;
        }
        .ab-btn:active::after { width: 300px; height: 300px; }
        .ab-btn-primary {
          background: linear-gradient(135deg, #0B3D91, #0B3D91);
          color: #ffffff;
          box-shadow: 0 3px 14px rgba(11,61,145,0.22);
        }
        .ab-btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 28px rgba(11,61,145,0.38);
        }
        .ab-btn-ghost {
          background: transparent;
          color: rgba(11,61,145,0.48);
          border: 1.5px solid rgba(11,61,145,0.07);
        }
        .ab-btn-ghost:hover {
          color: #0d1b2a;
          border-color: rgba(11,61,145,0.18);
          background: rgba(11,61,145,0.025);
        }
        .ab-btn-green {
          background: rgba(22,163,74,0.1);
          color: #16a34a;
          border: 1.5px solid rgba(22,163,74,0.18);
        }
        .ab-btn-green:hover {
          background: rgba(22,163,74,0.16);
          box-shadow: 0 4px 14px rgba(22,163,74,0.12);
        }
        .ab-btn-lg { padding: 14px 32px; font-size: 0.92rem; min-height: 52px; }

        /* ── ALERT ── */
        .ab-alert {
          padding: 12px 16px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          gap: 10px;
          font-weight: 500;
          font-size: 0.84rem;
          margin-bottom: 18px;
          animation: abPop 0.4s cubic-bezier(0.34,1.56,0.64,1);
          border: 1px solid;
        }
        .ab-alert-ok { background: rgba(22,163,74,0.06); border-color: rgba(22,163,74,0.15); color: #16a34a; }
        .ab-alert-err { background: rgba(220,38,38,0.06); border-color: rgba(220,38,38,0.15); color: #dc2626; }
        .ab-alert-warn { background: rgba(217,119,6,0.06); border-color: rgba(217,119,6,0.15); color: #d97706; }
        .ab-alert-info { background: rgba(11,61,145,0.06); border-color: rgba(11,61,145,0.15); color: #0369a1; }
        .ab-alert-icon {
          width: 32px; height: 32px; min-width: 32px;
          border-radius: 9px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.9rem;
        }
        .ab-alert-x {
          margin-left: auto;
          background: none;
          border: none;
          color: inherit;
          cursor: pointer;
          padding: 3px;
          opacity: 0.5;
          font-size: 0.85rem;
          transition: opacity 0.2s;
        }
        .ab-alert-x:hover { opacity: 1; }

        /* ── STATS ── */
        .ab-stats-main {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 10px;
          margin-bottom: 12px;
          animation: abUp 0.6s ease;
        }
        .ab-stats-age {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 10px;
          margin-bottom: 24px;
          animation: abUp 0.65s ease;
        }
        .ab-stat {
          background: linear-gradient(150deg, rgba(255,255,255,0.9), rgba(240,244,251,0.96));
          backdrop-filter: blur(16px);
          -webkit-backdrop-filter: blur(16px);
          border: 1px solid rgba(11,61,145,0.04);
          border-radius: 16px;
          padding: 18px 10px;
          text-align: center;
          transition: all 0.4s cubic-bezier(0.25,0.46,0.45,0.94);
          position: relative;
          overflow: hidden;
          cursor: default;
        }
        .ab-stat::after {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 2.5px;
          border-radius: 16px 16px 0 0;
          opacity: 0;
          transition: opacity 0.35s ease;
        }
        .ab-stat:hover {
          transform: translateY(-4px);
          border-color: rgba(11,61,145,0.07);
        }
        .ab-stat:hover::after { opacity: 1; }
        .ab-stat.purple::after { background: linear-gradient(90deg, #0B3D91, #0B3D91); }
        .ab-stat.purple:hover { box-shadow: 0 12px 36px rgba(11,61,145,0.1); }
        .ab-stat.green::after { background: linear-gradient(90deg, #16a34a, #16a34a); }
        .ab-stat.green:hover { box-shadow: 0 12px 36px rgba(22,163,74,0.1); }
        .ab-stat.red::after { background: linear-gradient(90deg, #dc2626, #dc2626); }
        .ab-stat.red:hover { box-shadow: 0 12px 36px rgba(220,38,38,0.08); }
        .ab-stat.blue::after { background: linear-gradient(90deg, #0B3D91, #0369a1); }
        .ab-stat.blue:hover { box-shadow: 0 12px 36px rgba(11,61,145,0.1); }
        .ab-stat.cyan::after { background: linear-gradient(90deg, #0369a1, #0369a1); }
        .ab-stat.cyan:hover { box-shadow: 0 12px 36px rgba(3,105,161,0.1); }
        .ab-stat.amber::after { background: linear-gradient(90deg, #d97706, #d97706); }
        .ab-stat.amber:hover { box-shadow: 0 12px 36px rgba(217,119,6,0.08); }

        .ab-stat-icon {
          width: 40px; height: 40px;
          border-radius: 12px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 1.05rem;
          margin-bottom: 8px;
          transition: transform 0.35s ease;
        }
        .ab-stat:hover .ab-stat-icon { transform: scale(1.12) rotate(-4deg); }
        .ab-stat-val {
          font-size: clamp(1.3rem, 2.8vw, 1.9rem);
          font-weight: 800;
          color: #0d1b2a;
          line-height: 1;
          margin-bottom: 3px;
          letter-spacing: -0.03em;
          animation: abCount 0.5s ease;
        }
        .ab-stat-lbl {
          font-size: 0.58rem;
          color: #64748b;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
        }
        .ab-stat-sub {
          font-size: 0.6rem;
          color: #94a3b8;
          margin-top: 3px;
        }
        .ab-progress {
          height: 3px;
          border-radius: 2px;
          background: rgba(11,61,145,0.03);
          margin-top: 8px;
          overflow: hidden;
        }
        .ab-progress-bar {
          height: 100%;
          border-radius: 2px;
          transition: width 0.8s ease;
        }

        /* ── GLASS PANEL ── */
        .ab-glass {
          background: linear-gradient(145deg, rgba(255,255,255,0.88), rgba(240,244,251,0.96));
          backdrop-filter: blur(20px) saturate(1.2);
          -webkit-backdrop-filter: blur(20px) saturate(1.2);
          border: 1px solid rgba(11,61,145,0.045);
          border-radius: 18px;
          transition: border-color 0.4s, box-shadow 0.4s;
          overflow: hidden;
        }
        .ab-glass:hover {
          border-color: rgba(11,61,145,0.08);
          box-shadow: 0 4px 24px rgba(15,23,42,0.18);
        }
        .ab-glass-body { padding: clamp(16px, 3.5vw, 36px); }

        /* ── FILTERS ── */
        .ab-filters {
          display: grid;
          grid-template-columns: 2fr repeat(3, 1fr);
          gap: 8px;
          margin-bottom: 20px;
          animation: abUp 0.7s ease;
        }
        .ab-search-wrap { position: relative; }
        .ab-search-icon {
          position: absolute;
          left: 13px; top: 50%;
          transform: translateY(-50%);
          color: rgba(11,61,145,0.16);
          font-size: 0.9rem;
          transition: color 0.3s;
          z-index: 2;
          pointer-events: none;
        }
        .ab-search-wrap:focus-within .ab-search-icon { color: #0B3D91; }
        .ab-search {
          width: 100%;
          padding: 11px 15px 11px 40px;
          background: rgba(240,244,251,0.5);
          border: 1.5px solid rgba(11,61,145,0.05);
          border-radius: 12px;
          color: #0d1b2a;
          font-size: 0.86rem;
          font-weight: 500;
          outline: none;
          transition: all 0.3s ease;
          font-family: inherit;
        }
        .ab-search::placeholder { color: rgba(11,61,145,0.18); }
        .ab-search:focus {
          border-color: #0B3D91;
          box-shadow: 0 0 0 3px rgba(11,61,145,0.08);
          background: rgba(240,244,251,0.75);
        }

        .ab-filter-btn {
          width: 100%;
          padding: 11px 12px;
          background: rgba(240,244,251,0.5);
          border: 1.5px solid rgba(11,61,145,0.045);
          border-radius: 12px;
          color: rgba(11,61,145,0.55);
          font-size: 0.8rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s;
          display: flex;
          align-items: center;
          gap: 6px;
          white-space: nowrap;
          font-family: inherit;
        }
        .ab-filter-btn:hover {
          border-color: rgba(11,61,145,0.1);
          color: rgba(11,61,145,0.8);
        }
        .ab-filter-btn.active {
          border-color: rgba(11,61,145,0.25);
          color: #0B3D91;
          background: rgba(11,61,145,0.05);
        }
        .ab-dropdown {
          position: absolute;
          top: calc(100% + 5px);
          left: 0; right: 0;
          background: rgba(240,244,251,0.97);
          backdrop-filter: blur(14px);
          border: 1px solid rgba(11,61,145,0.07);
          border-radius: 12px;
          box-shadow: 0 10px 36px rgba(15,23,42,0.5);
          z-index: 50;
          overflow: hidden;
          animation: abScale 0.18s ease;
        }
        .ab-drop-item {
          padding: 9px 13px;
          font-size: 0.8rem;
          color: rgba(11,61,145,0.55);
          cursor: pointer;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          gap: 7px;
          border: none;
          background: none;
          width: 100%;
          text-align: left;
          font-family: inherit;
        }
        .ab-drop-item:hover { background: rgba(11,61,145,0.06); color: #0d1b2a; }
        .ab-drop-item.sel { color: #0B3D91; background: rgba(11,61,145,0.04); }

        /* ── TABLE ── */
        .ab-table-wrap {
          border-radius: 13px;
          overflow: hidden;
          border: 1px solid rgba(11,61,145,0.03);
          position: relative;
        }
        .ab-table-scroll {
          max-height: 480px;
          max-width: 100%;
          overflow: auto;
          overscroll-behavior: contain;
          -webkit-overflow-scrolling: touch;
        }
        .ab-tbl {
          width: max(100%, 920px);
          border-collapse: separate;
          border-spacing: 0;
        }
        .ab-tbl thead { position: sticky; top: 0; z-index: 5; }
        .ab-tbl th {
          padding: 12px 15px;
          font-size: 0.62rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.1em;
          color: #0B3D91;
          border-bottom: 1px solid rgba(11,61,145,0.04);
          background: rgba(255,255,255,0.97);
          backdrop-filter: blur(8px);
          white-space: nowrap;
          text-align: left;
        }
        .ab-tbl td {
          padding: 12px 15px;
          font-size: 0.82rem;
          color: #374151;
          border-bottom: 1px solid rgba(11,61,145,0.02);
          vertical-align: middle;
        }
        .ab-tbl tbody tr { transition: all 0.2s; cursor: default; }
        .ab-tbl tbody tr:hover { background: rgba(11,61,145,0.035); }
        .ab-tbl tbody tr:last-child td { border-bottom: none; }

        .ab-tag {
          display: inline-flex;
          align-items: center;
          padding: 3px 9px;
          border-radius: 7px;
          font-size: 0.68rem;
          font-weight: 650;
          letter-spacing: 0.015em;
          border: 1px solid transparent;
          white-space: nowrap;
        }
        .ab-tag-purple { background: rgba(11,61,145,0.1); color: #0B3D91; border-color: rgba(11,61,145,0.18); }
        .ab-tag-blue { background: rgba(11,61,145,0.1); color: #0369a1; border-color: rgba(11,61,145,0.18); }
        .ab-tag-green { background: rgba(22,163,74,0.1); color: #16a34a; border-color: rgba(22,163,74,0.18); }
        .ab-tag-red { background: rgba(220,38,38,0.08); color: #dc2626; border-color: rgba(220,38,38,0.15); }
        .ab-tag-amber { background: rgba(217,119,6,0.1); color: #d97706; border-color: rgba(217,119,6,0.18); }
        .ab-tag-cyan { background: rgba(3,105,161,0.1); color: #0369a1; border-color: rgba(3,105,161,0.18); }
        .ab-tag-rose { background: rgba(220,38,38,0.08); color: #dc2626; border-color: rgba(220,38,38,0.15); }

        /* ── ACTION BTNS ── */
        .ab-act-grp { display: flex; gap: 5px; justify-content: center; }
        .ab-act {
          width: 34px; height: 34px;
          border-radius: 8px;
          border: 1.5px solid;
          background: transparent;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.25s;
          font-size: 0.78rem;
        }
        .ab-act:hover { transform: translateY(-2px); }
        .ab-act.view { border-color: rgba(3,105,161,0.22); color: #0369a1; }
        .ab-act.view:hover { background: rgba(3,105,161,0.08); box-shadow: 0 3px 10px rgba(3,105,161,0.16); }
        .ab-act.edit { border-color: rgba(11,61,145,0.22); color: #0B3D91; }
        .ab-act.edit:hover { background: rgba(11,61,145,0.08); box-shadow: 0 3px 10px rgba(11,61,145,0.16); }
        .ab-act.del { border-color: rgba(220,38,38,0.22); color: #dc2626; }
        .ab-act.del:hover { background: rgba(220,38,38,0.08); box-shadow: 0 3px 10px rgba(220,38,38,0.16); }

        /* ── MOBILE CARDS ── */
        .ab-cards { display: none; }
        .ab-card {
          background: rgba(240,244,251,0.5);
          border: 1px solid rgba(11,61,145,0.035);
          border-radius: 14px;
          padding: 14px;
          margin-bottom: 8px;
          transition: all 0.3s;
          animation: abUp 0.3s ease both;
        }
        .ab-card:active { background: rgba(11,61,145,0.03); border-color: rgba(11,61,145,0.1); }
        .ab-card-head {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 10px;
        }
        .ab-card-name { font-weight: 700; color: #0d1b2a; font-size: 0.92rem; margin-bottom: 4px; }
        .ab-card-tags { display: flex; gap: 5px; flex-wrap: wrap; }
        .ab-card-row {
          display: flex;
          justify-content: space-between;
          padding: 5px 0;
          border-bottom: 1px solid rgba(11,61,145,0.02);
          font-size: 0.78rem;
        }
        .ab-card-row:last-child { border-bottom: none; }
        .ab-card-lbl { color: #64748b; font-weight: 500; }
        .ab-card-val {
          color: #374151;
          font-weight: 600;
          text-align: right;
          max-width: 62%;
          overflow-wrap: anywhere;
        }
        .ab-card-actions {
          display: flex;
          gap: 6px;
          justify-content: flex-end;
          margin-top: 10px;
          padding-top: 8px;
          border-top: 1px solid rgba(11,61,145,0.025);
        }
        .ab-card-expand {
          text-align: center;
          padding: 6px;
          color: #94a3b8;
          font-size: 0.7rem;
          cursor: pointer;
        }

        /* ── PAGINATION ── */
        .ab-pagination {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 16px;
          padding-top: 14px;
          border-top: 1px solid rgba(11,61,145,0.035);
        }
        .ab-pg-info { font-size: 0.74rem; color: #64748b; }
        .ab-pg-btns { display: flex; gap: 3px; flex-wrap: wrap; justify-content: flex-end; }
        .ab-pg-btn {
          width: 36px; height: 36px;
          border-radius: 10px;
          border: 1px solid rgba(11,61,145,0.05);
          background: transparent;
          color: #64748b;
          font-size: 0.75rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: inherit;
        }
        .ab-pg-btn:hover:not(:disabled) {
          border-color: rgba(11,61,145,0.25);
          color: #0B3D91;
          background: rgba(11,61,145,0.05);
        }
        .ab-pg-btn.active {
          background: linear-gradient(135deg, #0B3D91, #0B3D91);
          border-color: transparent;
          color: #ffffff;
          box-shadow: 0 2px 8px rgba(11,61,145,0.25);
        }
        .ab-pg-btn:disabled { opacity: 0.25; cursor: not-allowed; }

        /* ── MODAL ── */
        .ab-overlay {
          position: fixed;
          inset: 0;
          background: rgba(15,23,42,0.72);
          backdrop-filter: blur(6px);
          z-index: 1000;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 14px;
          animation: abUp 0.2s ease;
        }
        .ab-modal {
          background: linear-gradient(155deg, rgba(255,255,255,0.98), rgba(240,244,251,0.99));
          border: 1px solid rgba(11,61,145,0.06);
          border-radius: 20px;
          width: 100%;
          max-width: 660px;
          max-height: 88vh;
          overflow-y: auto;
          animation: abScale 0.3s ease;
          box-shadow: 0 20px 70px rgba(15,23,42,0.55), 0 0 80px rgba(11,61,145,0.05);
        }
        .ab-modal-head {
          padding: 18px 22px;
          border-bottom: 1px solid rgba(11,61,145,0.04);
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: sticky;
          top: 0;
          background: rgba(240,244,251,0.98);
          backdrop-filter: blur(10px);
          z-index: 5;
          border-radius: 20px 20px 0 0;
        }
        .ab-modal-title {
          font-size: 1.1rem;
          font-weight: 800;
          color: #0d1b2a;
          display: flex;
          align-items: center;
          gap: 9px;
        }
        .ab-modal-x {
          width: 34px; height: 34px;
          border-radius: 10px;
          border: 1px solid rgba(11,61,145,0.07);
          background: rgba(11,61,145,0.02);
          color: #64748b;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s;
          font-size: 0.95rem;
        }
        .ab-modal-x:hover { color: #0d1b2a; border-color: rgba(11,61,145,0.18); background: rgba(11,61,145,0.05); }
        .ab-modal-body { padding: 22px; }
        .ab-modal-foot {
          padding: 14px 22px;
          border-top: 1px solid rgba(11,61,145,0.04);
          display: flex;
          gap: 8px;
          justify-content: flex-end;
        }

        /* ── FORM ── */
        .ab-form-grid {
          display: grid;
          gap: 14px;
          grid-template-columns: repeat(2, 1fr);
        }
        .ab-form-full { grid-column: 1 / -1; }
        .ab-field { position: relative; }
        .ab-label {
          display: block;
          font-size: 0.68rem;
          font-weight: 650;
          color: #64748b;
          margin-bottom: 6px;
          text-transform: uppercase;
          letter-spacing: 0.06em;
          transition: color 0.3s;
        }
        .ab-field:focus-within .ab-label { color: #0B3D91; }
        .ab-req { color: #dc2626; margin-left: 2px; }
        .ab-inp-wrap { position: relative; }
        .ab-inp-icon {
          position: absolute;
          left: 12px; top: 50%;
          transform: translateY(-50%);
          color: rgba(11,61,145,0.15);
          font-size: 0.88rem;
          transition: color 0.3s;
          z-index: 2;
          pointer-events: none;
        }
        .ab-field:focus-within .ab-inp-icon { color: #0B3D91; }
        .ab-inp {
          width: 100%;
          padding: 11px 12px 11px 38px;
          background: rgba(240,244,251,0.5);
          border: 1.5px solid rgba(11,61,145,0.055);
          border-radius: 11px;
          min-height: 46px;
          color: #0d1b2a;
          font-size: 0.88rem;
          font-weight: 500;
          outline: none;
          transition: all 0.3s;
          font-family: inherit;
          -webkit-appearance: none;
          appearance: none;
        }
        .ab-inp::placeholder { color: rgba(11,61,145,0.14); }
        .ab-inp:focus {
          border-color: #0B3D91;
          background: rgba(240,244,251,0.75);
          box-shadow: 0 0 0 3px rgba(11,61,145,0.08);
        }
        .ab-inp.err { border-color: #dc2626; }
        .ab-inp.err:focus { box-shadow: 0 0 0 3px rgba(220,38,38,0.1); }
        .ab-sel {
          width: 100%;
          padding: 11px 34px 11px 38px;
          background: rgba(240,244,251,0.5);
          border: 1.5px solid rgba(11,61,145,0.055);
          border-radius: 11px;
          min-height: 46px;
          color: #0d1b2a;
          font-size: 0.88rem;
          font-weight: 500;
          outline: none;
          transition: all 0.3s;
          cursor: pointer;
          font-family: inherit;
          -webkit-appearance: none;
          appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='rgba(11,61,145,0.28)' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 12px center;
        }
        .ab-sel:focus {
          border-color: #0B3D91;
          box-shadow: 0 0 0 3px rgba(11,61,145,0.08);
        }
        .ab-inp[type="file"] {
          padding: 10px 12px;
          min-height: 50px;
        }
        .ab-inp[type="file"]::file-selector-button {
          margin-right: 10px;
          border: 0;
          border-radius: 9px;
          padding: 9px 12px;
          font: inherit;
          font-weight: 700;
          background: rgba(11,61,145,0.16);
          color: #0d1b2a;
          cursor: pointer;
        }
        .ab-sel option { background: #ffffff; color: #0d1b2a; }
        .ab-err-msg { font-size: 0.68rem; color: #dc2626; margin-top: 3px; font-weight: 500; }

        /* ── DETAIL ── */
        .ab-detail-avatar {
          width: 60px; height: 60px;
          border-radius: 16px;
          background: linear-gradient(135deg, rgba(11,61,145,0.12), rgba(11,61,145,0.12));
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          color: #0B3D91;
          margin-bottom: 10px;
        }
        .ab-detail-avatar img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
        .ab-detail-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
        }
        .ab-detail-item {
          padding: 12px;
          background: rgba(240,244,251,0.45);
          border: 1px solid rgba(11,61,145,0.03);
          border-radius: 11px;
        }
        .ab-detail-lbl {
          font-size: 0.64rem;
          font-weight: 700;
          color: #64748b;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 3px;
        }
        .ab-detail-val { font-size: 0.9rem; font-weight: 600; color: #0d1b2a; }

        /* ── EMPTY / LOADER ── */
        .ab-empty { text-align: center; padding: 44px 16px; }
        .ab-empty-icon {
          width: 64px; height: 64px;
          border-radius: 18px;
          background: rgba(11,61,145,0.05);
          border: 1px solid rgba(11,61,145,0.08);
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          color: #94a3b8;
          margin-bottom: 14px;
          animation: abFloat 3s ease-in-out infinite;
        }
        .ab-loader {
          display: flex;
          gap: 5px;
          justify-content: center;
          padding: 44px;
        }
        .ab-loader span {
          width: 9px; height: 9px;
          border-radius: 50%;
          background: #0B3D91;
          animation: abDot 1.4s infinite ease-in-out both;
        }
        .ab-loader span:nth-child(1) { animation-delay: -0.32s; }
        .ab-loader span:nth-child(2) { animation-delay: -0.16s; }

        .ab-footer {
          text-align: center;
          margin-top: 32px;
          padding-bottom: 14px;
          color: #94a3b8;
          font-size: 0.7rem;
          font-weight: 500;
        }

        /* ── DOC VIEWER ── */
        .ab-doc-overlay {
          position: fixed;
          inset: 0;
          background: rgba(15,23,42,0.88);
          backdrop-filter: blur(8px);
          z-index: 2000;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 14px;
          animation: abUp 0.2s ease;
        }
        .ab-doc-box {
          background: rgba(240,244,251,0.98);
          border: 1px solid rgba(11,61,145,0.07);
          border-radius: 18px;
          width: 100%;
          max-width: 860px;
          height: min(88vh, 700px);
          display: flex;
          flex-direction: column;
          overflow: hidden;
          box-shadow: 0 24px 80px rgba(15,23,42,0.7);
          animation: abScale 0.25s ease;
        }
        .ab-doc-head {
          padding: 14px 18px;
          border-bottom: 1px solid rgba(11,61,145,0.05);
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-shrink: 0;
        }
        .ab-doc-title {
          font-size: 0.9rem;
          font-weight: 700;
          color: #0d1b2a;
          display: flex;
          align-items: center;
          gap: 8px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .ab-doc-content {
          flex: 1;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(11,61,145,0.6);
        }
        .ab-doc-content iframe {
          width: 100%;
          height: 100%;
          border: none;
        }
        .ab-doc-content img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          border-radius: 8px;
        }
        .ab-doc-btn {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          padding: 5px 12px;
          border-radius: 9px;
          font-size: 0.75rem;
          font-weight: 650;
          cursor: pointer;
          border: 1.5px solid rgba(22,163,74,0.25);
          background: rgba(22,163,74,0.07);
          color: #16a34a;
          transition: all 0.2s;
          font-family: inherit;
          white-space: nowrap;
        }
        .ab-doc-btn:hover { background: rgba(22,163,74,0.14); }
        .ab-ijy-btn {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          padding: 5px 11px;
          border-radius: 8px;
          font-size: 0.72rem;
          font-weight: 650;
          cursor: pointer;
          border: 1.5px solid rgba(22,163,74,0.22);
          background: rgba(22,163,74,0.06);
          color: #16a34a;
          transition: all 0.2s;
          font-family: inherit;
          white-space: nowrap;
        }
        .ab-ijy-btn:hover { background: rgba(22,163,74,0.14); transform: translateY(-1px); }

        /* ── RESPONSIVE ── */
        @media (max-width: 1024px) {
          .ab-stats-main { grid-template-columns: repeat(2, 1fr); }
          .ab-filters { grid-template-columns: 1fr 1fr; }
        }
        @media (max-width: 767px) {
          .ab-wrap { padding: 12px 10px 28px; }
          .ab-desktop-tbl { display: none !important; }
          .ab-cards { display: block !important; }
          .ab-filters { grid-template-columns: 1fr; }
          .ab-form-grid { grid-template-columns: 1fr; }
          .ab-detail-grid { grid-template-columns: 1fr; }
          .ab-modal { border-radius: 16px; max-height: 85vh; }
          .ab-modal-body { padding: 16px; }
          .ab-actions { justify-content: stretch; }
          .ab-actions .ab-btn { flex: 1; justify-content: center; }
          .ab-modal-foot { flex-direction: column; }
          .ab-modal-foot .ab-btn { width: 100%; justify-content: center; }
          .ab-pagination { flex-direction: column; align-items: center; }
          .ab-stats-age { grid-template-columns: repeat(3, 1fr); }
        }
        @media (max-width: 576px) {
          .ab-stat { padding: 14px 8px; border-radius: 12px; }
          .ab-stat-icon { width: 34px; height: 34px; font-size: 0.9rem; border-radius: 10px; margin-bottom: 6px; }
          .ab-stat-val { font-size: 1.15rem; }
          .ab-stat-lbl { font-size: 0.52rem; }
          .ab-stats-main, .ab-stats-age { gap: 7px; }
          .ab-glass { border-radius: 14px; }
          .ab-glass-body { padding: 12px; }
          .ab-inp, .ab-sel, .ab-search { font-size: 0.84rem; padding-top: 10px; padding-bottom: 10px; border-radius: 10px; }
          .ab-btn { padding: 9px 14px; font-size: 0.78rem; border-radius: 10px; }
          .ab-act { width: 38px; height: 38px; }
          .ab-pg-btns { justify-content: center; }
          .ab-card-actions { flex-wrap: wrap; }
          .ab-detail-avatar { width: min(100%, 180px) !important; height: 180px !important; border-radius: 20px !important; }
        }
        @media (max-width: 400px) {
          .ab-stats-main { grid-template-columns: repeat(2, 1fr); gap: 5px; }
          .ab-stats-age { gap: 5px; }
          .ab-stat-val { font-size: 1rem; }
        }
        @supports (-webkit-touch-callout: none) {
          .ab-shell { min-height: 100dvh; }
          .ab-inp, .ab-sel, .ab-search { font-size: 16px; }
        }
        @media (hover: none) and (pointer: coarse) {
          .ab-stat:hover { transform: none; box-shadow: none; }
          .ab-act:hover { transform: none; }
        }
      `}</style>

      <div className="ab-root">
        <div className="ab-shell">
          <div className="ab-layer">
            <div className="ab-wrap">

              {/* Header */}
              <div className="ab-header">
                <div className="ab-chip">
                  <i className="bi bi-person-hearts"></i>
                  Gucunga Abana
                </div>
                <h1 className="ab-title">Abana bo mu Mudugudu</h1>
                <p className="ab-sub">Gucunga no kugenzura amakuru y'abana bose</p>
              </div>

              {/* Actions */}
              <div className="ab-actions">
                <button className="ab-btn ab-btn-primary" onClick={() => { resetForm(); setShowModal(true); }}>
                  <i className="bi bi-person-plus-fill"></i> Ongeraho Umwana
                </button>
                <button className="ab-btn ab-btn-ghost" onClick={loadData}>
                  <i className="bi bi-arrow-clockwise"></i> Ongera
                </button>
                <button className="ab-btn ab-btn-green" onClick={exportCSV}>
                  <i className="bi bi-download"></i> Export Excel
                </button>
              </div>

              {/* Alert */}
              {alert && (
                <div className={`ab-alert ab-alert-${alert.variant}`}>
                  <div className="ab-alert-icon" style={{
                    background: alert.variant === "ok" ? "rgba(22,163,74,0.1)" :
                      alert.variant === "err" ? "rgba(220,38,38,0.1)" :
                      alert.variant === "warn" ? "rgba(217,119,6,0.1)" : "rgba(11,61,145,0.1)"
                  }}>
                    <i className={`bi bi-${
                      alert.variant === "ok" ? "check-lg" :
                      alert.variant === "err" ? "x-lg" :
                      alert.variant === "warn" ? "exclamation-lg" : "info-lg"
                    }`}></i>
                  </div>
                  {alert.message}
                  <button className="ab-alert-x" onClick={() => setAlert(null)}>✕</button>
                </div>
              )}

              {/* Stats Main */}
              <div className="ab-stats-main">
                <div className="ab-stat purple">
                  <div className="ab-stat-icon" style={{ background: "rgba(11,61,145,0.1)", color: "#0B3D91" }}>
                    <i className="bi bi-person-hearts"></i>
                  </div>
                  <div className="ab-stat-val">{stats.total}</div>
                  <div className="ab-stat-lbl">Abana Bose</div>
                  <div className="ab-stat-sub">{stats.male} Gabo · {stats.female} Gore</div>
                </div>
                <div className="ab-stat green">
                  <div className="ab-stat-icon" style={{ background: "rgba(22,163,74,0.1)", color: "#16a34a" }}>
                    <i className="bi bi-book-fill"></i>
                  </div>
                  <div className="ab-stat-val">{stats.inSchool}</div>
                  <div className="ab-stat-lbl">Abiga</div>
                  <div className="ab-progress">
                    <div className="ab-progress-bar" style={{ width: `${stats.total ? (stats.inSchool / stats.total * 100) : 0}%`, background: "linear-gradient(90deg,#16a34a,#16a34a)" }}></div>
                  </div>
                </div>
                <div className="ab-stat red">
                  <div className="ab-stat-icon" style={{ background: "rgba(220,38,38,0.08)", color: "#dc2626" }}>
                    <i className="bi bi-person-x-fill"></i>
                  </div>
                  <div className="ab-stat-val">{stats.notInSchool}</div>
                  <div className="ab-stat-lbl">Batiga</div>
                  <div className="ab-progress">
                    <div className="ab-progress-bar" style={{ width: `${stats.total ? (stats.notInSchool / stats.total * 100) : 0}%`, background: "linear-gradient(90deg,#dc2626,#dc2626)" }}></div>
                  </div>
                </div>
                <div className="ab-stat blue">
                  <div className="ab-stat-icon" style={{ background: "rgba(11,61,145,0.1)", color: "#0369a1" }}>
                    <i className="bi bi-calendar-heart"></i>
                  </div>
                  <div className="ab-stat-val">{stats.avgAge}</div>
                  <div className="ab-stat-lbl">Imyaka y'Imikurire</div>
                </div>
              </div>

              {/* Stats Age */}
              <div className="ab-stats-age">
                <div className="ab-stat cyan">
                  <div className="ab-stat-icon" style={{ background: "rgba(3,105,161,0.1)", color: "#0369a1" }}>
                    <i className="bi bi-emoji-smile"></i>
                  </div>
                  <div className="ab-stat-val">{stats.under5}</div>
                  <div className="ab-stat-lbl">Munsi ya 5</div>
                </div>
                <div className="ab-stat blue">
                  <div className="ab-stat-icon" style={{ background: "rgba(11,61,145,0.1)", color: "#0369a1" }}>
                    <i className="bi bi-backpack"></i>
                  </div>
                  <div className="ab-stat-val">{stats.age5to12}</div>
                  <div className="ab-stat-lbl">5–12 imyaka</div>
                </div>
                <div className="ab-stat amber">
                  <div className="ab-stat-icon" style={{ background: "rgba(217,119,6,0.1)", color: "#d97706" }}>
                    <i className="bi bi-mortarboard"></i>
                  </div>
                  <div className="ab-stat-val">{stats.age13to18}</div>
                  <div className="ab-stat-lbl">13–18 imyaka</div>
                </div>
              </div>

              {/* Filters */}
              <div className="ab-filters">
                <div className="ab-search-wrap">
                  <i className="bi bi-search ab-search-icon"></i>
                  <input className="ab-search" placeholder="Shakisha amazina, umubyeyi, aderesi..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
                </div>
                <DropFilter icon="gender-ambiguous" label="Igitsina" value={filterGender} onChange={setFilterGender}
                  options={[{ v: "all", l: "Byose" }, { v: "Gabo", l: "Gabo" }, { v: "Gore", l: "Gore" }]} />
                <DropFilter icon="book" label="Ishuri" value={filterSchool} onChange={setFilterSchool}
                  options={[{ v: "all", l: "Byose" }, { v: "Yego", l: "Abiga" }, { v: "Oya", l: "Batiga" }]} />
                <DropFilter icon="calendar-range" label="Imyaka" value={filterAge} onChange={setFilterAge}
                  options={[{ v: "all", l: "Byose" }, { v: "under5", l: "Munsi ya 5" }, { v: "5-12", l: "5–12" }, { v: "13-18", l: "13–18" }]} />
              </div>

              {/* Data Panel */}
              <div className="ab-glass" style={{ animation: "abScale 0.35s ease" }}>
                <div className="ab-glass-body">
                  {loading ? (
                    <div className="ab-loader"><span></span><span></span><span></span></div>
                  ) : pageItems.length === 0 ? (
                    <div className="ab-empty">
                      <div className="ab-empty-icon"><i className="bi bi-person-hearts"></i></div>
                      <h5 style={{ color: "#374151", fontWeight: 700, marginBottom: 4 }}>Nta bana bahari</h5>
                      <p style={{ color: "#64748b", fontSize: "0.82rem" }}>
                        {searchTerm || filterGender !== "all" || filterSchool !== "all" || filterAge !== "all"
                          ? "Hindura ibisuzuma" : "Tangira wongeraho amakuru"}
                      </p>
                    </div>
                  ) : (
                    <>
                      {/* Desktop Table */}
                      <div className="ab-desktop-tbl">
                        <div className="ab-table-wrap">
                          <div className="ab-table-scroll">
                            <table className="ab-tbl">
                              <thead>
                                <tr>
                                  <th style={{ paddingLeft: 18 }}>#</th>
                                  <th style={{ textAlign: "center", minWidth: 90 }}>Photos</th>
                                  <th>Amazina</th>
                                  <th style={{ textAlign: "center" }}>Imyaka</th>
                                  <th style={{ textAlign: "center" }}>Igitsina</th>
                                  <th>Umubyeyi</th>
                                  <th>Aderesi</th>
                                  <th style={{ textAlign: "center" }}>Ariga</th>
                                  <th style={{ textAlign: "center" }}>Ijyipande cy'amavuko</th>
                                  <th style={{ textAlign: "center" }}>Ibikorwa</th>
                                </tr>
                              </thead>
                              <tbody>
                                {pageItems.map((item, idx) => (
                                  <tr key={item.id} style={{ animation: `abSlide 0.3s ease ${idx * 0.035}s both` }}>
                                    <td style={{ paddingLeft: 18, color: "#94a3b8", fontWeight: 600 }}>{firstIdx + idx + 1}</td>
                                    <td style={{ textAlign: "center" }}>
                                      {getPhotoUrl(item.ifoto) ? (
                                        <img
                                          src={getPhotoUrl(item.ifoto)}
                                          alt={item.amazina}
                                          onError={handleImgError}
                                          style={{ width: 56, height: 56, borderRadius: 12, objectFit: "cover", border: "2px solid rgba(11,61,145,0.18)", display: "block", margin: "0 auto" }}
                                        />
                                      ) : (
                                        <span style={{ color: "#94a3b8", fontSize: "0.78rem", fontWeight: 600 }}>
                                          No Photo
                                        </span>
                                      )}
                                    </td>
                                    <td>
                                      <span style={{ fontWeight: 700, color: "#0d1b2a" }}>{item.amazina}</span>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <span className={`ab-tag ${getAgeTagClass(item.imyaka)}`}>{item.imyaka}</span>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <span className={`ab-tag ${item.igitsina === "Gabo" ? "ab-tag-blue" : "ab-tag-rose"}`}>{item.igitsina}</span>
                                    </td>
                                    <td>
                                      <i className="bi bi-person-fill" style={{ color: "rgba(11,61,145,0.15)", marginRight: 5, fontSize: "0.75rem" }}></i>
                                      {item.umubyeyi_wa_mwana}
                                    </td>
                                    <td>{item.aderesi || <span style={{ color: "rgba(11,61,145,0.12)" }}>—</span>}</td>
                                    <td style={{ textAlign: "center" }}>
                                      <span className={`ab-tag ${item.ariga === "Yego" ? "ab-tag-green" : "ab-tag-red"}`}>
                                        {item.ariga === "Yego" ? "Yego" : "Oya"}
                                      </span>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.ijyipande_cy_amavuko ? (
                                        <button
                                          className="ab-ijy-btn"
                                          onClick={() => openDocViewer(item.ijyipande_cy_amavuko)}
                                        >
                                          <i className="bi bi-file-earmark-medical-fill"></i>
                                          Reba
                                        </button>
                                      ) : (
                                        <span style={{ color: "rgba(11,61,145,0.12)", fontSize: "0.85rem" }}>—</span>
                                      )}
                                    </td>
                                    <td>
                                      <div className="ab-act-grp">
                                        <button className="ab-act view" title="Reba" onClick={() => { setSelectedChild(item); setShowDetail(true); }}>
                                          <i className="bi bi-eye"></i>
                                        </button>
                                        <button className="ab-act edit" title="Hindura" onClick={() => handleEdit(item)}>
                                          <i className="bi bi-pencil"></i>
                                        </button>
                                        <button className="ab-act del" title="Siba" onClick={() => handleDelete(item.id)}>
                                          <i className="bi bi-trash3"></i>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      {/* Mobile Cards */}
                      <div className="ab-cards">
                        {pageItems.map((item, idx) => {
                          const isExp = expandedCard === item.id;
                          return (
                            <div key={item.id} className="ab-card" style={{ animationDelay: `${idx * 0.035}s` }}
                              onClick={() => setExpandedCard(isExp ? null : item.id)}>
                              <div className="ab-card-head">
                                <div style={{ display: "flex", gap: 10, alignItems: "flex-start", minWidth: 0 }}>
                                  {getPhotoUrl(item.ifoto) ? (
                                    <img
                                      src={getPhotoUrl(item.ifoto)}
                                      alt={item.amazina}
                                      onError={handleImgError}
                                      style={{ width: 46, height: 46, borderRadius: "50%", objectFit: "cover", border: "2px solid rgba(11,61,145,0.18)", flexShrink: 0 }}
                                    />
                                  ) : (
                                    <div style={{ width: 46, height: 46, borderRadius: "50%", background: "rgba(11,61,145,0.08)", border: "1px solid rgba(11,61,145,0.14)", display: "flex", alignItems: "center", justifyContent: "center", color: "#0B3D91", flexShrink: 0 }}>
                                      <i className="bi bi-person-heart"></i>
                                    </div>
                                  )}
                                  <div>
                                    <div className="ab-card-name">{item.amazina}</div>
                                    <div className="ab-card-tags">
                                      <span className={`ab-tag ${item.igitsina === "Gabo" ? "ab-tag-blue" : "ab-tag-rose"}`}>{item.igitsina}</span>
                                      <span className={`ab-tag ${getAgeTagClass(item.imyaka)}`}>{item.imyaka} imyaka</span>
                                    </div>
                                  </div>
                                </div>
                                <span className={`ab-tag ${item.ariga === "Yego" ? "ab-tag-green" : "ab-tag-red"}`}>
                                  {item.ariga === "Yego" ? "Ariga" : "Ntabiga"}
                                </span>
                              </div>
                              <div className="ab-card-row">
                                <span className="ab-card-lbl">Umubyeyi</span>
                                <span className="ab-card-val">{item.umubyeyi_wa_mwana || "—"}</span>
                              </div>
                              <div className="ab-card-row">
                                <span className="ab-card-lbl">Aderesi</span>
                                <span className="ab-card-val">{item.aderesi || "—"}</span>
                              </div>
                              {isExp && (
                                <div style={{ animation: "abUp 0.25s ease" }}>
                                  <div className="ab-card-actions" onClick={e => e.stopPropagation()}>
                                    <button className="ab-act view" onClick={() => { setSelectedChild(item); setShowDetail(true); }}>
                                      <i className="bi bi-eye"></i>
                                    </button>
                                    <button className="ab-act edit" onClick={() => handleEdit(item)}>
                                      <i className="bi bi-pencil"></i>
                                    </button>
                                    <button className="ab-act del" onClick={() => handleDelete(item.id)}>
                                      <i className="bi bi-trash3"></i>
                                    </button>
                                  </div>
                                </div>
                              )}
                              <div className="ab-card-expand">
                                <i className={`bi bi-chevron-${isExp ? "up" : "down"}`}></i>
                              </div>
                            </div>
                          );
                        })}
                      </div>

                      {renderPagination()}
                    </>
                  )}
                </div>
              </div>

              {/* ═══ IN-APP DOCUMENT VIEWER ═══ */}
              {viewerFile && <InAppViewer filename={viewerFile} onClose={closeDocViewer} />}

              {/* ═══ ADD/EDIT MODAL ═══ */}
              {showModal && (
                <div className="ab-overlay" onClick={() => setShowModal(false)}>
                  <div className="ab-modal" style={{ maxWidth: 720, width: "min(92vw, 720px)" }} onClick={e => e.stopPropagation()}>
                    <div className="ab-modal-head">
                      <div className="ab-modal-title">
                        <i className={`bi bi-${editId ? "pencil-square" : "person-plus-fill"}`} style={{ color: "#0B3D91" }}></i>
                        {editId ? "Hindura Amakuru y'Umwana" : "Ongeraho Umwana"}
                      </div>
                      <button className="ab-modal-x" onClick={() => setShowModal(false)}>✕</button>
                    </div>
                    <div className="ab-modal-body">
                      <div className="ab-form-grid">
                        <div className="ab-field">
                          <label className="ab-label">Amazina<span className="ab-req">*</span></label>
                          <div className="ab-inp-wrap">
                            <i className="bi bi-person ab-inp-icon"></i>
                            <input className={`ab-inp${formErrors.amazina ? " err" : ""}`} name="amazina" value={form.amazina} onChange={handleChange} placeholder="Amazina y'umwana" />
                          </div>
                          {formErrors.amazina && <div className="ab-err-msg">{formErrors.amazina}</div>}
                        </div>
                        <div className="ab-field">
                          <label className="ab-label">Imyaka<span className="ab-req">*</span></label>
                          <div className="ab-inp-wrap">
                            <i className="bi bi-calendar3 ab-inp-icon"></i>
                            <input className={`ab-inp${formErrors.imyaka ? " err" : ""}`} type="number" name="imyaka" value={form.imyaka} onChange={handleChange} placeholder="0-18" min="0" max="18" />
                          </div>
                          {formErrors.imyaka && <div className="ab-err-msg">{formErrors.imyaka}</div>}
                        </div>
                        <div className="ab-field">
                          <label className="ab-label">Igitsina<span className="ab-req">*</span></label>
                          <div className="ab-inp-wrap">
                            <i className="bi bi-gender-ambiguous ab-inp-icon"></i>
                            <select className="ab-sel" name="igitsina" value={form.igitsina} onChange={handleChange}>
                              <option value="Gabo">Gabo</option>
                              <option value="Gore">Gore</option>
                            </select>
                          </div>
                        </div>
                        <div className="ab-field">
                          <label className="ab-label">Ariga</label>
                          <div className="ab-inp-wrap">
                            <i className="bi bi-book ab-inp-icon"></i>
                            <select className="ab-sel" name="ariga" value={form.ariga} onChange={handleChange}>
                              <option value="Yego">Yego — Ariga</option>
                              <option value="Oya">Oya — Ntabiga</option>
                            </select>
                          </div>
                        </div>
                        <div className="ab-field">
                          <label className="ab-label">Umubyeyi<span className="ab-req">*</span></label>
                          <div className="ab-inp-wrap">
                            <i className="bi bi-person-heart ab-inp-icon"></i>
                            <input className={`ab-inp${formErrors.umubyeyi_wa_mwana ? " err" : ""}`} name="umubyeyi_wa_mwana" value={form.umubyeyi_wa_mwana} onChange={handleChange} placeholder="Amazina y'umubyeyi" />
                          </div>
                          {formErrors.umubyeyi_wa_mwana && <div className="ab-err-msg">{formErrors.umubyeyi_wa_mwana}</div>}
                        </div>
                        <div className="ab-field">
                          <label className="ab-label">Aderesi</label>
                          <div className="ab-inp-wrap">
                            <i className="bi bi-geo-alt ab-inp-icon"></i>
                            <input className="ab-inp" name="aderesi" value={form.aderesi} onChange={handleChange} placeholder="Aho batuye" />
                          </div>
                        </div>
                        <div className="ab-field ab-form-full">
                          <label className="ab-label">Ifoto</label>
                          <input
                            className={`ab-inp${formErrors.ifoto ? " err" : ""}`}
                            style={{ paddingLeft: 12 }}
                            type="file"
                            accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                            onChange={handleFileChange}
                          />
                          {formErrors.ifoto && <div className="ab-err-msg">{formErrors.ifoto}</div>}
                          {(selectedFile?.name || form.ifoto) && (
                            <div style={{ fontSize: "0.72rem", color: "#64748b", marginTop: 6 }}>
                              {selectedFile ? "Ifoto yatoranijwe" : "Ifoto iriho"}: {selectedFile?.name || form.ifoto}
                            </div>
                          )}
                        </div>
                        {/* Ijyipande cy'amavuko */}
                        <div className="ab-field ab-form-full">
                          <label className="ab-label">
                            <i className="bi bi-file-medical-fill" style={{ marginRight: 5, color: "#16a34a" }}></i>
                            Ijyipande cy'Amavuko (Health Record)
                          </label>
                          <input
                            className={`ab-inp${formErrors.ijyipande_cy_amavuko ? " err" : ""}`}
                            style={{ paddingLeft: 12 }}
                            type="file"
                            accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (!file) { setSelectedIjyipande(null); return; }
                              if (file.size > 5 * 1024 * 1024) {
                                setFormErrors(p => ({ ...p, ijyipande_cy_amavuko: "Dosiye ntigomba kurenza 5MB" }));
                                e.target.value = ""; return;
                              }
                              setSelectedIjyipande(file);
                              setFormErrors(p => { const n = { ...p }; delete n.ijyipande_cy_amavuko; return n; });
                            }}
                          />
                          {formErrors.ijyipande_cy_amavuko && <div className="ab-err-msg">{formErrors.ijyipande_cy_amavuko}</div>}
                          <div style={{ fontSize: "0.68rem", color: "#64748b", marginTop: 4 }}>
                            Injiza ijyipande cy'amavuko (JPG, PNG, PDF — max 5MB)
                          </div>
                          {(selectedIjyipande?.name || form.ijyipande_cy_amavuko) && (
                            <div style={{ fontSize: "0.72rem", color: "#16a34a", marginTop: 5 }}>
                              <i className="bi bi-paperclip me-1"></i>
                              {selectedIjyipande ? selectedIjyipande.name : form.ijyipande_cy_amavuko}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="ab-modal-foot">
                      <button className="ab-btn ab-btn-ghost" onClick={() => setShowModal(false)}>Funga</button>
                      <button className="ab-btn ab-btn-primary" onClick={handleSave}>
                        <i className={`bi bi-${editId ? "check-lg" : "plus-lg"}`}></i>
                        {editId ? "Hindura" : "Bika Amakuru"}
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* ═══ DETAIL MODAL ═══ */}
              {showDetail && selectedChild && (
                <div className="ab-overlay" onClick={() => setShowDetail(false)}>
                  <div className="ab-modal" onClick={e => e.stopPropagation()}>
                    <div className="ab-modal-head">
                      <div className="ab-modal-title">
                        <i className="bi bi-person-badge" style={{ color: "#0369a1" }}></i>
                        Amakuru Arambuye
                      </div>
                      <button className="ab-modal-x" onClick={() => setShowDetail(false)}>✕</button>
                    </div>
                    <div className="ab-modal-body">
                      <div style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                        gap: 20,
                        alignItems: "center",
                        textAlign: "center",
                        marginBottom: 22,
                      }}>
                        <div className="ab-detail-avatar" style={{
                          overflow: "hidden",
                          padding: 0,
                          width: "min(100%, 220px)",
                          height: 220,
                          borderRadius: 24,
                          margin: "0 auto",
                          boxShadow: "0 24px 48px rgba(11,61,145,0.45)",
                        }}>
                          {getPhotoUrl(selectedChild.ifoto) ? (
                            <img
                              src={getPhotoUrl(selectedChild.ifoto)}
                              alt={selectedChild.amazina}
                              onError={handleImgError}
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            />
                          ) : (
                            <div style={{
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 8,
                              padding: "0 16px",
                              textAlign: "center",
                            }}>
                              <i className="bi bi-person-heart" style={{ fontSize: "2.8rem" }}></i>
                              <span style={{ color: "rgba(11,61,145,0.72)", fontSize: "0.82rem", fontWeight: 600 }}>
                                No Photo Available
                              </span>
                            </div>
                          )}
                        </div>
                        <div>
                          <div style={{
                            fontSize: "0.74rem",
                            textTransform: "uppercase",
                            letterSpacing: "0.14em",
                            color: "#64748b",
                            marginBottom: 10,
                          }}>
                            Ifoto y'umwirondoro
                          </div>
                          <h3 style={{ fontWeight: 800, color: "#0d1b2a", fontSize: "1.5rem", marginBottom: 8 }}>{selectedChild.amazina}</h3>
                          <p style={{ color: "rgba(11,61,145,0.55)", fontSize: "0.88rem", marginBottom: 12 }}>
                            Ifoto nini ifasha kumenya neza umwana uri muri Amakuru Arambuye.
                          </p>
                          <div style={{ display: "flex", gap: 6, justifyContent: "center", flexWrap: "wrap" }}>
                            <span className={`ab-tag ${selectedChild.igitsina === "Gabo" ? "ab-tag-blue" : "ab-tag-rose"}`}>{selectedChild.igitsina}</span>
                            <span className={`ab-tag ${getAgeTagClass(selectedChild.imyaka)}`}>{selectedChild.imyaka} imyaka</span>
                            <span className={`ab-tag ${selectedChild.ariga === "Yego" ? "ab-tag-green" : "ab-tag-red"}`}>
                              {selectedChild.ariga === "Yego" ? "Ariga" : "Ntabiga"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="ab-detail-grid">
                        {[
                          { l: "Amazina", v: selectedChild.amazina, i: "person" },
                          { l: "Imyaka", v: selectedChild.imyaka, i: "calendar3" },
                          { l: "Igitsina", v: selectedChild.igitsina, i: "gender-ambiguous" },
                          { l: "Umubyeyi", v: selectedChild.umubyeyi_wa_mwana || "—", i: "person-heart" },
                          { l: "Aderesi", v: selectedChild.aderesi || "—", i: "geo-alt" },
                          { l: "Ariga", v: selectedChild.ariga === "Yego" ? "Yego — Ariga" : "Oya — Ntabiga", i: "book" },
                        ].map((d, i) => (
                          <div key={i} className="ab-detail-item">
                            <div className="ab-detail-lbl">
                              <i className={`bi bi-${d.i}`} style={{ marginRight: 4 }}></i>{d.l}
                            </div>
                            <div className="ab-detail-val">{d.v}</div>
                          </div>
                        ))}
                        {selectedChild.ijyipande_cy_amavuko && (
                          <div className="ab-detail-item" style={{ gridColumn: "1 / -1" }}>
                            <div className="ab-detail-lbl">
                              <i className="bi bi-file-medical-fill" style={{ marginRight: 4 }}></i>Ijyipande cy'Amavuko
                            </div>
                            <div style={{ marginTop: 8 }}>
                              <button
                                className="ab-doc-btn"
                                onClick={() => openDocViewer(selectedChild.ijyipande_cy_amavuko)}
                              >
                                <i className="bi bi-eye-fill"></i> Reba Dosiye
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="ab-modal-foot">
                      <button className="ab-btn ab-btn-ghost" onClick={() => setShowDetail(false)}>Funga</button>
                      <button className="ab-btn ab-btn-primary" onClick={() => { setShowDetail(false); handleEdit(selectedChild); }}>
                        <i className="bi bi-pencil"></i> Hindura
                      </button>
                    </div>
                  </div>
                </div>
              )}

              <div className="ab-footer">
                <i className="bi bi-shield-lock-fill" style={{ marginRight: 5 }}></i>
                Amakuru yose arindwa — akoreshwa ku buryo bw'amategeko
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Abana;